import React, { useEffect, useState } from 'react';
import AdminHeader from 'src/globals/Layout/Admin/AdminHeader';
import { HddOutlined, CloseCircleOutlined, SearchOutlined, PlusCircleOutlined, LockOutlined, UserOutlined, CreditCardOutlined, MailOutlined, PhoneOutlined, EditOutlined, DeleteOutlined, ExperimentOutlined, FundOutlined, FolderAddOutlined } from '@ant-design/icons';

import TPortafolioMyOrganizations from './TPortafolioMyOrganizations';
import { connect } from 'react-redux';
import { getParentOrganizationsByUser, getAllOrganization, getOrganizationsByParentOrganizationId } from 'src/store/organization/thunks';
import { AppState } from 'src/store';
import TPortafolioOrganizations, { DataTypePortafolio } from './TPortafolioOrganizations';
import TActivityDataPortfolio from './TActivityDataPortfolio';
import { Button, Col, DatePicker, Form, Input, InputNumber, Popconfirm, Row, Select, Space, Table, Tooltip } from 'antd';
import validateMessages from 'src/globals/Inputs/validateMessages';
import style from '../Tables.module.scss'
import { RequiredMark } from 'antd/es/form/Form';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { validateNumber } from 'src/globals/Inputs/validateInput';
import { Loan, OrganizationEvent } from 'src/store/portfolio/types';
import dayjs from 'dayjs';
import { ColumnsType } from 'antd/es/table';
import { getOrgObservations } from 'src/store/portfolio/thunks';
interface TPortafolioGeiProps {
    organizationData: DataTypePortafolio | undefined;
    getOrgObservations?: any;

}

const TPortafolioEvents: React.FC<TPortafolioGeiProps> = (props: TPortafolioGeiProps) => {
    const [dataTable, setDataTable] = useState([]);
    const { Option } = Select;
    const [formPortfolio] = Form.useForm();
    const [requiredMark, setRequiredMarkType] = useState<RequiredMark>('optional');
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const [dataTablePortfolio, setDataTablePortfolio] = useState([]);
    const [isType, setType] = useState(false);
    const init = async () => {
        const responseData = await props.getOrgObservations(props.organizationData?.id)
        if (responseData.length != 0) {
            setType(true);
            setDataTablePortfolio(responseData);
        } else {
            setType(false);
        }


    }
    useEffect(() => {
        init();
    }, [props.organizationData]);
    const onRegisterPortfolio = async (values: any) => {

    }
    const onFormLayoutChange = ({ size }: { size: SizeType }) => {
        setComponentSize(size);
    };

    const columnsLoans: ColumnsType<OrganizationEvent> = [
        {
            title: 'Observación',
            width: 25,
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Responsable',
            width: 15,
            dataIndex: 'userName',
            key: 'userName',
        },
        {
            title: 'Acción',
            width: 25,
            dataIndex: 'message',
            key: 'message',
        },
    ];

    return (
        <div>
            <AdminHeader>Observaciones de {" " + props.organizationData?.name}</AdminHeader>
           {isType ? <Table size="small" columns={columnsLoans} dataSource={dataTablePortfolio} scroll={{ x: 500 }} />:
           <><h2>No dispone de observaciones</h2></>}


        </div>

    );
};

const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {
    getOrgObservations
})(TPortafolioEvents);